import { initTsrReactQuery } from '@ts-rest/react-query/v5'
import { useRecoilState } from 'recoil'
import { contract } from '../../../../server/src/tsr-contracts'
import { tokenState } from '../../store/atoms/token'

export const useTsrClient = () => {
  const [idToken] = useRecoilState(tokenState)

  return initTsrReactQuery(contract, {
    baseUrl: window.location.origin,
    baseHeaders: {
      authorization: `${idToken ? `Bearer ${idToken.__raw}` : ''}`,
    },
  })
}
